import { I18nText as I18n, i18nKeys } from '@gloat/glocalize';

const monthsDisplay = (months: number, withAbbreviation: boolean) => {
  return withAbbreviation ? (
    <I18n data={{ count: months }} id={i18nKeys.COUNT_MONTH_ABBREVIATION} />
  ) : (
    <I18n data={{ count: months }} id={i18nKeys.COUNT_MONTH} />
  );
};

const yearsDisplay = (years: number, withAbbreviation: boolean) => {
  return withAbbreviation ? (
    <I18n data={{ count: years }} id={i18nKeys.COUNT_YEAR_ABBREVIATION} />
  ) : (
    <I18n data={{ count: years }} id={i18nKeys.COUNT_YEAR} />
  );
};

const monthsAsYears = (duration: number, withAbbreviation = true as boolean) => {
  const years = Math.floor(duration / 12);
  const months = duration % 12;

  // M month(s)
  if (duration < 12) {
    return monthsDisplay(months, withAbbreviation);
  }

  // Y year(s)
  if (months === 0) {
    return yearsDisplay(years, withAbbreviation);
  }

  // Y year(s) M month(s)
  return (
    <span>
      {yearsDisplay(years, withAbbreviation)} {monthsDisplay(months, withAbbreviation)}
    </span>
  );
};

export default monthsAsYears;
